export enum FFScope {
    BrokerPortal = 'BrokerPortal',
    Venus = 'Venus'
}

export const VenusFeatures = {
    HeavyTruckTypeForAutoCommercial: '4e9c8283a37cac4ee31d05ae7c6e171f'
};

export const BrokerPortalFeatureCodes = {
    EnableFusionAuth: '2cb8b8784011507e43817976aa12cca5',
    HEUFAssetsForGreen: '5b4801f19911cde745193d812233a245',
    EnableGettingContractDocuments: 'e4553cc6df038576fd7b3ff96caa0e08',
    EnablePLServicingCalculator: 'a72da199f2266507306055ee224cc985',
    EnableAutoServicingCalculator: '288b2063565f6ed32e5e6ebb071cde06',
    EnableCecSystemsOnDemandSearch: '1d4de9664307fe294fe68b7707b6ed80',
    RedirectToFusionAuthResetPassword: '5252236becc89cc134ff75dea2cc016e',
    DisableBrokerUpdateBrokerFeeWithDirectLinkApp: 'f4195b1aab4961b4ec585299fd8c6da6',
    EnableManualRateInput: 'ff934c579ff334e86a76668a7575b34e',
    ShowExpiryDate: '5e41cf6959a76cf25505fb01797c66ba',
    ValidatedObjectAsAdditionalResource: '8e883a30cb8920b33b5a076b5b3c80a9',
    FillGapsInFlattenedData: 'b9a818fd4b9da00ebcba31a5d69c7e69',
    ShouldHideInterestRateForCreatedApp: 'd410dff7767def0212162f969953557f',
    EnableNewEvLogic: 'bd915c5b52a4f60a9bf0d3a0ed9c730e',
    InterestFreeAirconAsset: 'd2d61f29e04f0992e1acecb8f228fa39',
    EnableDisplayedSiteInspectionForm: '0d4c438bf44c07a626ea1572e34df78e',
    HideBrokerLedInterestFreeJourney: 'af8c6b6ad30634f2137565b0c028590f',
    DisplayCustomerLedInterestFreeJourney: '955b837f1845aee350d74fa12356519b',
    EnableSendingInterestFreeApplicationLinkViaSms: '83a0572e25416338e368e75a6db37e69',
    MultipleBatteryInput: '8471e350ebda130d4b36a412c0e87fbc',
    UseDocumentReviewUploadDialog: 'b4f595d7be4e5c9a8100f8e0c3444208',
    UseBankStatementReviewUpload: 'ad67106b05d3a52918333df03f70f554',
    EnableResendQuoteButton: '21203c1a71d01aae518f210361afb0a9',
    EnableRepaymentStructureUpdate: 'c70b2ae74513889ecc5ec26f1cc200ce',
    EnableCommercialQuotingTool: 'e8095f2db62c1c76f5a3e8cb5e5c2d69',
    EnableTermTypeUpdate: '108230b1b8331f68722574c2553c4892',
    EnableCommercialQuotingToolOnLandingPage: '46eb7bc16777c919b8bb4db368c2134d',
    EnableTruckAssetCostValidation: 'ccb96eba898b47a931522c37959f3257',
    GeneralReportStatusForFilter: '6a644b2529b362eae2652b0d24932317',
    UpdatedGstTier3RequirementAutoCommercial: 'b16e73b408ee975546bda0c3ffe66ea3',
    EnableHeslpCard: '1356f00e6dd37499cb5268e4e8fd8c32',
    AddedAdditionalToolsSectionForCommercial: '897b2e737cc4b404aab71c55244a5319',
    UpdatedCommercialBrokerFeeCap: '03f7a31e027eb564cdd5993b0ac78858'
};

export const getFeatureName = (featureCode: string) => {
    const brokerPortalFeature = (Object.keys(
        BrokerPortalFeatureCodes
    ) as (keyof typeof BrokerPortalFeatureCodes)[]).find(key => {
        return BrokerPortalFeatureCodes[key] === featureCode;
    });

    if (brokerPortalFeature) {
        return brokerPortalFeature;
    }

    const venusFeature = (Object.keys(VenusFeatures) as (keyof typeof VenusFeatures)[]).find(key => {
        return VenusFeatures[key] === featureCode;
    });

    return venusFeature;
};
